// extracted by mini-css-extract-plugin
export default {"answers":"Answers_answers__-hR9x","answer":"Answers_answer__k+WPW","correct":"Answers_correct__1svZr","wrong":"Answers_wrong__DsyE3"};